import useGSAP from 'hooks/useGSAP'
import InnovativeFeatures from './InnovativeFeatures'
import OctImages from './OctImages'
import OctImagingCatheter from './OctImagingCatheter'
import Specifications from './Specifications'
import Banner from './Banner'
import MultimodalityTechnology from './MultimodalityTechnology'
import OctSolutions from './OctSolutions'
import InformedUs from 'organisms/informedUs'
import SubFooter from 'organisms/subFooter'

export default function index() {
  useGSAP('.innvolight-master')
  return (
    <main className="innvolight-master">
      <Banner />
      <InnovativeFeatures />
      <MultimodalityTechnology />
      <OctSolutions />
      <OctImages />
      <OctImagingCatheter />
      <Specifications />
      <InformedUs
        featureCardsList={[]}
        columnClasses=" md:max-w-6xl md:grid-cols-2 lg:grid-cols-2 lg:max-w-7xl xl:grid-cols-3 grid"
        // columnClasses=" md:max-w-xl lg:max-w-3xl 2xl:max-w-4xl"
        actionCardsList={{
          showReadMore: false,
          showDownload: true,
          showContact: true,
          showFindMore: false,
          showReqDemo: true,
          // showNewDownload: true,
        }}
        title={
          <span className="text-white">
            Want to get informed about <br className="hidden md:block" />
            <span className="font-bold text-orange">InnvoLight</span>?
          </span>
        }
        bgGrad="linear-gradient(180deg, #0b161f 0%, #272d36 100%)"
        fileLink="/brochures/Innvolight.pdf"
        fileName="InnvoLight"
        productTarget="/products/innvoLight/"
      />
      <SubFooter />
    </main>
  )
}
